<template>
    <div class="list-raovat list-raovat-epxired">
        <fillter
        v-model="data_fillter"
        @callAction="actionAdd($event)"
        :idSelect="idSelect"/>
        <table :class="{
                'table': true,
                'table-bordered': $detect == 'web'
            }">
            <thead v-if="$detect == 'web'">
                <tr>
                    <th scope="col" rowspan="2"  class="text-center">
                        STT
                    </th>
                    <th rowspan="2" class="text-center">Ảnh</th>
                    <th scope="col" rowspan="2">Danh mục(VG)</th>
                    <th scope="col" rowspan="2">Danh mục(GH)</th>
                    <th scope="col" rowspan="2">Cấp con</th>
                    <th scope="col" rowspan="2">Thuộc nhóm</th>
                    <th scope="col" rowspan="2">Thứ tự</th>
                    <th scope="col" colspan="3" class="text-center">Hiện thị </th>
                    <th scope="col" rowspan="2">không hiển thị trên menu trái</th>
                    <th scope="col" rowspan="2" class="text-center">Thao tác</th>
                </tr>
                <tr>
                    <th scope="col">Trang chủ</th>
                    <th scope="col">Icon trang chủ</th>
                    <th scope="col">Cấp con</th>
                </tr>
            </thead>
            <thead v-else>
                <tr>
                    <th scope="col" class="text-center py-1">
                       Icon
                    </th>
                    <th scope="col" class="text-center py-1">Thông tin</th>
                </tr>
            </thead>
            <tbody v-if="userCategory.length == 0">
                <tr>
                    <td colspan="12" class="text-center text-muted">Không có dữ liệu</td>
                </tr>
            </tbody>
            <tbody v-else-if="$detect == 'web'" >
                <tr class="position-relative" v-for="(item,index) in userCategory" :key="index">
                    <td scope="row" class="text-center" style="white-space: nowrap;">
                       {{index+1}}
                    </td>
                    <td width="50" class="position-relative">
                        <img class="img-web" :src="item.image" onerror="errorImage(this)"/>
                    </td>
                    <td class="name-rv">
                        <div>
                            <a class="text-decoration-none" :href="$linkUrl(item.link)" target="_blank">
                                <span class="name-item">{{ item.nCat }} </span> <span v-if="item.count != null">({{item.count}})</span>
                            </a>
                        </div>
                        <div v-for="(value,key) in arrSub" :key="key" class="ml-3 cat-child" v-if="item.iCat == value.ucs_category_id">
                            <span>{{value.ucs_name}}</span>
                        </div>
                    </td>
                    <td class="name-rv">
                        <div>
                            <span class="name-item">{{ item.cat_name_alias }} </span>
                        </div>
                    </td>
                    <td width="100" class="position-relative">
                        <p class="mb-0 text-danger fw-600" ></p>
                    </td>
                    <td width="100" class="position-relative">
                        <p class="mb-0 text-danger fw-600"> {{arrGroup[item.id].ucg_name}}</p>
                    </td>
                    <td width="50" class="position-relative text-center">
                        <p class="mb-0 fw-400 font-12px">{{ item.order }}</p>
                    </td>
                    <td width="50" class="position-relative text-center">
                        <i class="icon ion-ios-checkmark-circle-outline font-22px text-success" v-if="item.homepage == 1"></i>
                        <i class="icon ion-ios-close-circle-outline font-22px text-danger" v-else></i>
                    </td>
                    <td width="50" class="position-relative text-center">
                        <i class="icon ion-ios-checkmark-circle-outline font-22px text-success" v-if="item.homepage_icon == 1"></i>
                        <i class="icon ion-ios-close-circle-outline font-22px text-danger" v-else></i>
                    </td>
                    <td width="50" class="position-relative text-center">
                        <i class="icon ion-ios-checkmark-circle-outline font-22px text-success" v-if="item.show_child == 1"></i>
                        <i class="icon ion-ios-close-circle-outline font-22px text-danger" v-else></i>
                    </td>
                    <td width="50" class="position-relative text-center">
                        <i class="icon ion-ios-checkmark-circle-outline font-22px text-success" v-if="item.hide == 1"></i>
                        <i class="icon ion-ios-close-circle-outline font-22px text-danger" v-else></i>
                    </td>
                    <td width="150" class="text-center">
                        <button type="button" class="btn btn-primary btn-sm px-3 mr-2"
                            @click="edit(item, index)" :disabled="index === loading && loadingAction == 'availability'">
                             <i class="icon ion-md-create"></i>
                        </button>
                        <button type="button" class="btn btn-danger btn-sm px-3"
                            @click="destrory(item, index)" :disabled="index === loading && loadingAction == 'destrory'">
                            <i class="icon ion-md-trash"></i>
                        </button>
                    </td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr class="table-mobile" v-for="(item,index) in userCategory" :key="index" >
                    <td class="img-tab-1 position-relative pl-1">
                        <div class="checkbox-mobile position-absolute">
                         
                        </div>
                        <div class="icon-cat">
                            <img :src="item.image" onerror="errorImage(this)" @click="pushIdMuti(item)"/>
                        </div>
                    </td>
                    <td>
                        <div class="name">
                            <a class="text-decoration-none" :href="item.link" target="_blank">
                                <span class="name-item text-primary">{{ item.nCat }}</span>
                            </a>
                            <span v-if="item.count !=null">({{item.count}})</span>
                            <div>
                                <span class="name-item">{{ item.cat_name_alias }} </span>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div class="info-cat w-100 d-flex align-items-center border-top border-left border-right">
                                <div class="w-50 text-center">
                                     Thuộc nhóm 
                                </div>
                                 <div class="w-50 border-left">
                                    <div class="text-center text-danger">
                                        {{arrGroup[item.id] ? arrGroup[item.id].ucg_name : ''}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div class="info-cat w-100 d-flex align-items-center border">
                                <div class="w-30 text-center">
                                    Hiển thị
                                </div>
                                <div class="w-50 border-left">
                                    <div class="ml-1 border-bottom">Trang chủ:</div>
                                    <div class="ml-1 border-bottom">Icon Trang chủ:</div>
                                    <div class="ml-1">Cấp con</div>
                                </div>
                                <div class="w-20 border-left">
                                    <div class="text-center">
                                        <i class="icon ion-ios-checkmark-circle-outline  text-success" v-if="item.homepage == 1"></i>
                                        <i class="icon ion-ios-close-circle-outline  text-danger" v-else></i>
                                    </div>
                                    <div class="text-center">
                                        <i class="icon ion-ios-checkmark-circle-outline  text-success" v-if="item.homepage_icon == 1"></i>
                                        <i class="icon ion-ios-close-circle-outline  text-danger" v-else></i>
                                    </div>
                                    <div class="text-center">
                                        <i class="icon ion-ios-checkmark-circle-outline  text-success" v-if="item.show_child == 1"></i>
                                        <i class="icon ion-ios-close-circle-outline  text-danger" v-else></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div class="info-cat w-100 d-flex align-items-center border-left border-bottom border-right">
                                <div class="w-80 text-center">
                                    Không hiển thị trên menu trái
                                </div>
                                <div class="w-20 border-left">
                                    <div class="text-center">
                                        <i class="icon ion-ios-checkmark-circle-outline  text-success" v-if="item.hide == 1"></i>
                                        <i class="icon ion-ios-close-circle-outline  text-danger" v-else></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mt-2">
                            <button type="button"
                                class="btn btn-primary btn-sm mr-2 w-btn"
                                @click="edit(item, index)" :disabled="index === loading && loadingAction == 'availability'">
                                Sửa
                            </button>
                            <button type="button" class="btn btn-danger btn-sm ml-2 w-btn"
                                @click="destrory(item, index)" >
                                Xoá
                            </button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <paginate
            :current_page="current_page"
            :next_page="next_page"
            :last_page="last_page"
            :callData="getUserCategory"/>
        <actionDialog
            :action="action"
            :visible.sync="dialog"
            :data="itemaction"
            :arrGroup="arrGroup"
            :multiple="false"/>
    </div>
</template>

<script>
import { availability, destroy } from '@/config/product';
export default {
    components: {
        fillter: () => import('./fillter.vue'),
        actionDialog : () => import('./actionDialog.vue'),
        paginate: () => import('@/components/layout/pagination.vue'),
    },
    data() {
        return {
            iCat : 0,
            userCategory: [],
            idSelect: [],
            last_page: 0,
            next_page: 0,
            current_page: 0,
            data_fillter: {
                status: 0,
                keyword: '',
            },
            selectAll: false,
            loading: '',
            loadingAction: '',
            arrSub : [],
            arrGroup: [],
            action: '', 
            dialog: false, 
            itemaction: '', // data xử lý đơn



        }
    },
    created() {
        this.getUserCategory(1);
        this.$eventBus.$on('call-page-expire', () => {
            this.idSelect = [];
            this.getDataAction(this.current_page);
        });
    },
    methods: {
        actionAdd(check){
            this.action = check;
            this.dialog = true;
        },
        edit(item,key){
            this.itemaction = item;
            this.action = 'edit';
            this.dialog = true;
        },
        getUserCategory(page) {
            let params = {
                page: page,
                status: this.data_fillter.status,
                keyword: this.data_fillter.keyword,
            };
            this.idSelect = [];
            this.selectAll = false;
            apiGet('v2/profile/products/get_user_category', params).then(res => {
                this.userCategory = res.data.arrListing.data;
                this.last_page = res.data.arrListing.last_page;
                this.next_page = res.data.arrListing.next_page;
                this.current_page = res.data.arrListing.current_page;
                this.selectAll = false;
                this.arrSub =  res.data.arrSub;
                this.arrGroup = res.data.arrGroup;
                // this.arrSubColor = res.data.arrSubColor;
                // this.arrPromotionStatus = res.data.arrPromotionStatus;
                // this.arrDataSizeColor = res.data.arrDataSizeColor;
            })

        },
        async destrory(item, index = null){
            this.loading = index;
            this.loadingAction = 'destrory';
            await this.$confirm('Bạn có chắc chắn xóa danh mục sản phẩm này?', 'Xóa danh mục sản phẩm', {
                confirmButtonText: 'Đồng ý',
                cancelButtonText: 'Hủy',
                type: 'error'
            }).then(async res => {
                await apiPost('v2/profile/products/delete_user_category', {
                    record_id: item.iCat,
                }).then(res => {
                    this.$message({
                            message: res.message,
                            type: 'success',
                            center: true,
                        });
                }).catch(err => {
                    if(err.status == 410){
                        this.$message({
                            message: err.data.message,
                            type: 'error',
                            center: true,
                        });
                        
                     }
                })
            }).catch(() => {})
            
            await this.getDataAction(this.current_page);
        },
        async getDataAction(page){
            if(page < 1) return;
            let params = {
                page: page,
                status: this.data_fillter.status,
                keyword: this.data_fillter.keyword,
            };
            this.idSelect = [];
            this.selectAll = false;
            let data = {};
            await apiGet('v2/profile/products/get_user_category', params).then(res => {
                if(res.data.current_page == 1){
                    this.userCategory = res.data.arrListing.data;
                    this.last_page =  res.data.arrListing.last_page;
                    this.next_page =  res.data.arrListing.next_page;
                    this.current_page =  res.data.arrListing.current_page;
                    this.arrSub =  res.data.arrSub;
                    this.arrGroup = res.data.arrGroup;
                }
                data = res.data;
            });

            if(data.arrListing.data.length == 0){
                this.getDataAction(page - 1);
            }else{
                this.userCategory = data.arrListing.data;
                this.last_page = data.arrListing.last_page;
                this.next_page = data.arrListing.next_page;
                this.current_page = data.arrListing.current_page;
            }
        }
    },
    watch: {
        data_fillter: {
            handler(val){
                this.getUserCategory(1)
            },
            deep: true
        },
        selectAll(val){
            this.idSelect = [];
            if(val){
                this.userCategory.map(item => {
                    this.idSelect.push(item.id);
                })
            }
        },
        idSelect: {
            handler(val){
                let count = 0;
                this.userCategory.map(item => {
                    count += 1;
                });
                if(val.length == count && count > 0){
                    this.selectAll = true;
                }
            },
            deep: true,
        },
        dialog(){
            this.getUserCategory(this.current_page)
        }

    }
}
</script>

<style lang="scss">
    .border{
        border: 1px solid #e5e5e5;
    }
    .border-top{
        border-top: 1px solid #e5e5e5;
    }
    .border-left{
        border-left: 1px solid #e5e5e5;
    }
    .border-right{
        border-right: 1px solid #e5e5e5;
    }
    .border-bottom{
        border-bottom: 1px solid #e5e5e5;
    }
    .w-80{
        width : 80%;
    }
    .w-30{
        width : 30%;
    }
    .w-20{
        width : 20%;
    }
    
    .img-tab-1{
        padding-left: 0;
        .icon-cat{
            img{
                width: 50px !important;
                height: 50px !important;
                object-fit: cover;
                border-radius: 10px;
                box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
            }
        }
    }
    .font-12px{
        font-size: 12px;
    }
    .text-oranges{
        color : #fd7e14;
    }
    .table-mobile {
        .w-btn {
            width: calc( 50% - 8px );
        }
        .checkbox-mobile {
            top: 19px !important;
            left: 7px !important;
        }
    }
    .price-tab-old{
        margin-top: 3px;
        font-size: 12px;
        text-decoration-line: line-through;
        color: #6c757d;
    }
    .text-promotion{
        margin-top: 3px;
        font-size: 11px;
    }
    .table thead th {
        vertical-align : middle;
    }
    .list-raovat table .name-rv{
        display : revert;
    }
    .font-22px{
        font-size : 22px;
    }
    .name-rv{
        .cat-child{
            font-size: 13px;
        }
    }

</style>
